import { ColorNordicGrey1, Spacing16, Spacing32 } from 'autogen/design-tokens/tokens';
import {
    type GiftCardInfoBox,
    IBasketPrizeCertificateInfoBoxDiscriminator,
    type BasketCheckoutButtonModel,
    type BasketFooterViewModel
} from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import Voucher from 'components/basket/Voucher/Voucher';
import PersonalOffer from 'components/basket/personalOffer';
import BasketSummary from 'components/checkout/components/BasketOverview/components/BasketSummary';
import PrizeCertificate from 'components/checkout/components/PrizeCertificate';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import CheckoutActions from '../BasketCheckoutActions/CheckoutActions';
import PaymentByGiftCard from 'components/pages/Checkout/components/SummaryPage/components/PaymentByGiftCard/PaymentByGiftCard';

/* #region styles */

const Footer = styled.div`
    display: grid;
    gap: ${Spacing32};
    grid-template-columns: 1fr;
    border-top: 1px solid ${ColorNordicGrey1};
    padding-top: ${Spacing16};

    ${breakpoint.up(sizes.lg)} {
        grid-template-columns: 1fr 1fr;
    }
`;

const Divider = styled.hr`
    display: block;
    width: 100%;
    border-top: none;
    margin: 0;
    border-bottom: 1px solid ${ColorNordicGrey1};
`;

/* #endregion */
export default function BasketFooter({
    model: { basketSummary, prizeCertificate, personalOfferInfo, isReadOnly, voucher, isCouponVoucherEnabled },
    checkoutButtonModel,
    giftCardInfo
}: {
    model: BasketFooterViewModel;
    checkoutButtonModel: BasketCheckoutButtonModel;
    giftCardInfo?: GiftCardInfoBox;
}) {
    return (
        <Footer>
            {!isReadOnly && (
                <Flex.Column>
                    {personalOfferInfo && (
                        <>
                            <PersonalOffer model={personalOfferInfo} />
                            <Divider />
                        </>
                    )}
                    {prizeCertificate && (
                        <>
                            <PrizeCertificate model={prizeCertificate} />
                            <Divider />
                        </>
                    )}
                    {voucher && isCouponVoucherEnabled && <Voucher model={voucher} />}
                    {giftCardInfo && <PaymentByGiftCard model={giftCardInfo} alignment="start" />}
                </Flex.Column>
            )}

            <Flex.Column>
                <BasketSummary model={basketSummary} />
                <CheckoutActions model={checkoutButtonModel} />
            </Flex.Column>
        </Footer>
    );
}
